export default __webpack_public_path__ + "static/media/gallery04.c36a695f.png";